/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React, {useCallback} from 'react';

export const useNoop = () => {
  const noop =  useCallback(function() { }, []);
  return noop;
};
